module.exports = __webpack_public_path__ + "img/horizontal_3_4_9006.25b4521c.png";